import { useTranslation } from "react-i18next";
import IUserDataProps from "../identity/user-data";
export interface Module {
	name: string;
	code: string;
	clientPath: string;
	childModules: Array<Module>;
}

export enum ModulesEnum {
	home = "0",
	library = "1",
	agreements = "2",
	cases = "3",
	financials = "4",
	data = "5",
	simulator = "8",
}

const menuOrder = ["library", "simulator", "home", "agreements", "cases", "financials", "data"];

export enum ServiceModulesEnum {
	lyfeLines = "6",
	support = "7",
}

const platformClientRelevantModules = Object.keys(ModulesEnum).map((k) => (ModulesEnum as any)[k]);
export const getOnlyPlatformRelevant = (modules: Array<Module>) =>
	modules.filter((module) => platformClientRelevantModules.includes(module.code));

export enum SubModulesEnum {
	"home-overview" = "0.1",

	"library-overview" = "1.1",

	"agreements-overview" = "2.1",

	"cases-overview" = "3.1",

	"financials-overview" = "4.1",

	"data-overview" = "5.1",
	"data-forms" = "5.2",
	"data-uploads" = "5.3",
	"data-integrations" = "5.4",
	"data-validation" = "5.5",
	"data-mappings" = "5.6",
	"data-generation" = "5.7",

	"simulator-overview" = "8.1",
}

const getModule = (moduleType: object, code: string) => {
	const module = Object.entries(moduleType).find(([, value]) => value === code);

	if (!module) throw new Error(`Unknown moduleCode: ${code}`);

	return module;
};

const getSubModuleName = (moduleCode: string) => getModule(SubModulesEnum, moduleCode)[0];
const getModuleName = (moduleCode: string) => getModule(ModulesEnum, moduleCode)[0];

const getModuleNameAndLink = (moduleCode: string) => {
	const module = getModuleName(moduleCode);
	return {
		name: module,
		link: module,
	};
};

export const useModuleRouteData = (user: IUserDataProps) => {
	const { t } = useTranslation();

	if (user.exposedResource) {
		return {
			modulesData: [
				{
					main: {
						key: "document",
						name: t("document-review"),
						link: "document",
					},
					subModules: [],
				},
			],
			firstAvailableModule: "document",
		};
	}

	const modules = getOnlyPlatformRelevant(user.modules);
	const firstAvailableModule = modules && modules.length > 0 ? getModuleNameAndLink(modules[0].code).link : "noModule";

	const sortedModules = modules.sort((a, b) => {
		return menuOrder.indexOf(a.name.toLowerCase()) - menuOrder.indexOf(b.name.toLowerCase());
	});

	const modulesData = sortedModules.map((m, i) => {
		const { name, link } = getModuleNameAndLink(m.code);
		return {
			main: {
				key: m.code,
				name: t(name),
				link,
			},
			subModules: m.childModules.map((sm) => ({
				key: sm.code,
				name: t(getSubModuleName(sm.code)),
				link: sm.clientPath, //we should rather build the link in the client and not store it on the Auth DB, this is a mixing of concerns
			})),
		};
	});

	return { firstAvailableModule, modulesData };
};

export const supportLink = "support@lyfegen.com";
export const supportLinkWithProtocol = "mailto:support@lyfegen.com";
